<!--
 * @Author: chengleilei
 * @Date: 2025-09-23 14:06:40
 * @Description: 收货地址管理弹窗
-->
<template>
    <Modal v-model="isShow" :width="1000" title="收货地址管理" @on-cancel="onCancel">
        <TableFormNew ref="tableFormNewRef" :formList="formList" @onSubmit="onSubmit" @onReset="onReset" />
        <TablePage :list="tableConfig" @onPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" />
        <div slot="footer">
            <Button type="text" @click="onCancel">关闭</Button>
        </div>
    </Modal>
</template>

<script>
import { apiPurchaseAddressList, apiPurchaseAddressSetDefault, apiPurchaseAddressRemove } from '@/api/purchase';
import TableFormNew from '@/components/tableFormNew';
import TablePage from '@/components/tablePage';
import { clearInvalidKey } from '@/libs/util.tool';
import { renderButton } from '@/libs/util';
import { addressColumns } from '../const';

export default {
    components: { TableFormNew, TablePage },
    data() {
        return {
            isShow: false,
            formList: [
                {
                    type: 'input',
                    label: '关键字',
                    prop: 'addressStr',
                    placeholder: '请输入地址/联系人/联系手机',
                },
            ],
            tableConfig: {
                current: 1,
                size: 5,
                total: 0,
                columns: [
                    ...addressColumns,
                    {
                        title: '操作',
                        width: 170,
                        fixed: 'right',
                        render: (h, p) => {
                            return [
                                p.row.isDefault
                                    ? renderButton(h, { text: '默认地址', type: 'success' })
                                    : renderButton(h, { text: '设为默认', type: 'primary' }, () => {
                                          this.setDefault(p.row);
                                      }),
                                renderButton(h, { text: '删除', type: 'error' }, () => {
                                    this.deleteAddress(p.row);
                                }),
                            ];
                        },
                    },
                ],
                data: [{ isDefault: true }, { isDefault: false }],
                loading: false,
            },
        };
    },
    methods: {
        // 打开弹窗
        open() {
            this.isShow = true;
            this.getData();
        },
        // 弹窗取消
        onCancel() {
            this.tableConfig.current = 1;
            this.tableConfig.size = 5;
            this.isShow = false;
        },
        // 获取参数
        getParams() {
            const formData = this.$refs['tableFormNewRef'].getFormData();
            const params = {
                current: this.tableConfig.current,
                size: this.tableConfig.size,
                ...formData,
            };
            return clearInvalidKey(params);
        },
        // 获取列表数据
        async getData() {
            try {
                this.tableConfig.loading = true;
                const res = await apiPurchaseAddressList(this.getParams());
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = res.list;
            } finally {
                this.tableConfig.loading = false;
            }
        },
        // 查询
        onSubmit() {
            this.tableConfig.current = 1;
            this.getData();
        },
        // 重置
        onReset() {
            this.tableConfig.current = 1;
            this.tableConfig.size = 5;
            this.getData();
        },
        // current-change
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        // size-change
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
        // 设置默认地址
        async setDefault(row) {
            await apiPurchaseAddressSetDefault({ id: row.id });
            this.$Message.success('设置成功');
            this.getData();
        },
        // 删除地址
        deleteAddress(row) {
            this.$Modal.confirm({
                title: '删除',
                content: `您确定删除该地址吗？`,
                onOk: async () => {
                    await apiPurchaseAddressRemove({ id: row.id });
                    this.$Message.success('删除成功');
                    this.getData();
                    this.$emit('onDelete', row.id);
                },
            });
        },
    },
};
</script>
